import axios from "axios";
import { b2cSalesPersonDashboardApi, b2cInterestedLeadsApi, b2cDashboardUpdateApi, b2cLeadDetailApi, b2cLeadPhoneStatsApi, b2cAdminLeadDashboardApi, b2cLeadApi, b2cExcelUploadAndAssignApi, b2cExcelDownloadAndAssignApi, b2cAddSingleLeadApi, b2cNpcLeadsSheetDownloadApi } from "../constants/apis";
import { getUserId, getUserToken } from "../helpers/local_storage_helpers";

export const getB2CSalesPersonDashboard = async (query) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(`${b2cSalesPersonDashboardApi}?${query}`, config);
    return response;
};

export const getB2CInterestedLeads = async (query) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(`${b2cInterestedLeadsApi}?${query}`, config);
    return response;
};

export const getB2CLeadPhoneStats = async (query) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(`${b2cLeadPhoneStatsApi}${query}`, config);
    return response;
};

export const updateB2CLeadStatus = async (assignmentId, data) => {
    const isFormData = data instanceof FormData;
    const config = {
        headers: {
            "Authorization": `Token ${getUserToken()}`,
        },
    };
    if (!isFormData) {
        config.headers["Content-Type"] = "application/json";
    }
    // assignmentId is used in the URL as per user request: /lead-manager/b2c-dashboard-update/<assignment_id>/
    const response = await axios.patch(`${b2cDashboardUpdateApi}${assignmentId}/`, data, config);
    return response;
};

export const updateB2CLead = async (assignmentId, data) => {
    const isFormData = data instanceof FormData;
    const config = {
        headers: {
            "Authorization": `Token ${getUserToken()}`,
        },
    };
    if (!isFormData) {
        config.headers["Content-Type"] = "application/json";
    }
    const response = await axios.patch(`${b2cLeadApi}${assignmentId}/`, data, config);
    return response;
};

export const downloadB2CLeads = async (params) => {
    const config = {
        headers: {
            "Authorization": `Token ${getUserToken()}`,
        },
        responseType: 'blob',
    };
    const response = await axios.get(`${b2cExcelDownloadAndAssignApi}?${params}`, config);
    return response;
};

export const uploadAndAssignB2CLeads = async (formData) => {
    const config = {
        headers: {
            "Content-Type": "multipart/form-data",
            "Authorization": `Token ${getUserToken()}`,
        },
    };
    const response = await axios.post(b2cExcelUploadAndAssignApi, formData, config);
    return response;
};

export const getB2CLeadDetail = async (id, isAssignmentId = true) => {
    try {
        const url = isAssignmentId ? `${b2cLeadDetailApi}?assignment_id=${id}` : `${b2cLeadDetailApi}?lead_id=${id}`;
        const response = await axios.get(url, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Token ${getUserToken()}`,
            },
        });
        return response;
    } catch (error) {
        console.error("Error fetching B2C lead detail:", error);
        throw error;
    }
};

export const updateB2CLeadDetail = async (id, payload) => {
    try {
        const url = `${b2cLeadDetailApi}${id}/`;
        const response = await axios.patch(url, payload, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Token ${getUserToken()}`,
            },
        });
        return response;
    } catch (error) {
        console.error("Error updating B2C lead detail:", error);
        throw error;
    }
};

export const getB2CAdminLeadDashboard = async (query) => {
    try {
        const config = {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Token ${getUserToken()}`,
            },
        };
        const response = await axios.get(`${b2cAdminLeadDashboardApi}${query ? `?${query}` : ''}`, config);
        return response;
    } catch (error) {
        console.error("Error fetching B2C admin lead dashboard:", error);
        throw error;
    }
};

export const downloadB2CNpcLeadsSheet = async (params) => {
    const config = {
        headers: {
            "Authorization": `Token ${getUserToken()}`,
        },
        responseType: 'blob',
    };
    const response = await axios.get(`${b2cNpcLeadsSheetDownloadApi}${params ? `?${params}` : ''}`, config);
    return response;
};

export const addB2CSingleLead = async (payload) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };
    const response = await axios.post(b2cAddSingleLeadApi, payload, config);
    return response;
};
